import React, { Component } from "react";
import "./SectionLabel.css";

class SectionLabel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { text, style, className } = this.props;

    return (
      <div className={`section-label ${className}`} style={{ ...style }}>
        <div className="color-tag" />
        <h3 className="text">{text}</h3>
      </div>
    );
  }
}

export default SectionLabel;
